import { Query, SearcherFactory } from "@m31coding/fuzzy-search";
import { Account } from "models/account";

import type { PermissionKey } from "components/ToolsPageLayout/ToolsPageTabs";
import { Tool, tools } from "consts/tools";

const searcher = SearcherFactory.createDefaultSearcher();

searcher.indexEntities(
  tools,
  (e: any) => e.id,
  (e: any) => [e.title, e.description, `${e.title} ${e.description}`]
);

export const toolSearch = (query: string, loggedInAccount: Account | null) => {
  const searchResult = searcher.getMatches(new Query(query, 30, 0.14));
  const filteredTools = searchResult.matches
    .map((m) => ({
      ...(m.entity as Tool),
      matchedString: m.matchedString,
      quality: m.quality,
    }))
    .filter((t) => {
      return !t.permission || loggedInAccount?.[t.permission as PermissionKey];
    });

  return filteredTools;
};
